export default __webpack_public_path__ + "static/media/hero_section.1aa4f6a1.jpg";